<template>
  <div class="flex flex-wrap mb-2" :style="guideStep == 111 ? { zIndex: 100, position: 'relative' } : null">
    <div class="w-full lg:w-3/4 flex-1 min-w-0 bg-white rounded-xl space-y-6 p-3 lg:p-6">
      <div>
        <span v-if="false" class="text-red-500">*</span>
        <span class="text-grap-700 align-middle">{{lang['components']['Event']['CampaignName']['title']}}</span>
      </div>
      <div>
        <input
          :disabled="editPageType"
          class="w-full rounded-md border p-1"
          type="text"
          v-model="campaignName"
        />
      </div>
    </div>
    <div class="hidden lg:block w-1/4 rounded-xl space-y-2 px-4 event-tips-sidebar">
      <div
        class="flex bg-white rounded-xl space-y-1 px-4 py-2 text-gray-500 h-20"
        v-if="teachingId == 0"
      >
        <img :src="lightImg" class="h-8 w-8" />
        <div class="px-2 text-sm">
          {{lang['components']['Event']['CampaignName']['teaching_text_1']}}<a href="#" class="text-gray-700 underline" @click="openTeaching()"
            >{{lang['components']['Event']['CampaignName']['teaching_text_2']}}>></a
          >
        </div>
        <!-- <i class="pi pi-times cursor-pointer text-right"></i> -->
      </div>
    </div>
    <!-- 新手教學 -->
    <div v-if="guideStep == 111" style="width: 100%; height: 100vh; position: absolute; top: 0; background-color: rgba(0,0,0,0);"></div>
  </div>
</template>
<script>
import lightImg from "@/assets/light.png";

export default {
  name: "CampaignName",
  components: {},
  props: {
    // <!-- 新手教學 -->
    guideStep: {
      type: Number,
      default: -1
    },
    teachingId: {
      type: Number,
    },
    // <!-- 新手教學 -->
    editPage: {
      type: Boolean
    },
    viewDatalist: {
      type: String
    },
    lang: {
      type: Object
    },
  },
  data() {
    return {
      lightImg: lightImg,
      campaignName: ''
    };
  },
  watch:{
    'lang':function(v){
      //console.log('CampaignName watch this.lang');
      //console.log(this.lang);
    },
    'viewDatalist':function(v){
      //console.log('viewDatalist：'+v);
      this.campaignName = v
    },
    campaignName (value){
      //console.log('value：'+value);
      // this.viewDatalist = value;
      this.$emit('childCampaignName', value);
      // console.log('viewDatalistData：'+this.viewDatalist);
    }
  },
  methods: {
    openTeaching(){
      this.$emit('childOpenTeaching', 111);
    }
  },
  computed: {
    editPageType: {
      get: function () {
        return this.editPage
      },
      set: function (value) {
        this.$emit('update:editPageType', value)
      },
    },
    // viewDatalistData: {
    //   get: function () {
    //     return this.viewDatalist
    //   },
    //   set: function (value) {
    //     this.$emit('update:viewDatalistData', value)
    //   },
    // },
  }
};
</script>
<style lang="scss" scope>
.remarketing {
  .p-multiselect-label-container {
    display: none;
  }
}
</style>
